import type { FC } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { PushNotificationService } from 'common/services';
import { useAppDispatch } from 'features/app/hooks';
import { showNotification } from 'features/notification/store';

export const PushNotificationHandler: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (!PushNotificationService.getInstance().getNotificationPermission()) {
      dispatch(
        showNotification({
          severity: 'warning',
          title: t('pushNotifications.permissionDeniedWarn'),
        })
      );
    }

    if (!window.matchMedia('(display-mode: standalone)').matches) {
      return;
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Legacy browsers require returnValue for the prompt to fire.
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
